/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import styled from 'styled-components';
import { Media } from '../../../styles/utilities';

/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledResponsiveFlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${Media.Tablet`
    flex-direction: row;
  `}
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledResponsiveFlexContainer/index.js